import { Home, Building2, Cog, Cable } from "lucide-react";
import { HOME_SERVICES } from "@/data/site";
import { Reveal } from "@/components/Reveal";

const ICONS = { home: Home, building: Building2, gear: Cog, cable: Cable };

export const CoreServices = () => (
  <section className="bg-[#F4F6F9]" data-testid="services-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24">
      <Reveal>
        <p className="font-mono-tech text-xs font-semibold uppercase tracking-[0.35em] text-[#FF5B00]" data-testid="services-kicker">
          Our Services
        </p>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-[1.05] tracking-tight text-[#0B0F19] sm:text-4xl lg:text-5xl" data-testid="services-heading">
          Complete Electrical
          <br />
          &amp; Fiber Optic Solutions
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[#475569]" data-testid="services-text">
          SMS Electrical &amp; Fiber Optic Installers provides professional electrical and fiber optic services for
          homes, businesses and industrial projects. We deliver safe, reliable and high-quality work with a focus on
          performance and long-term value.
        </p>
      </Reveal>

      <div className="grid gap-5 sm:grid-cols-2">
        {HOME_SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.1}>
              <div
                className="group h-full bg-white p-6 shadow-[0_2px_16px_rgba(11,15,25,0.07)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_28px_rgba(11,15,25,0.12)]"
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <div className="flex h-12 w-12 items-center justify-center text-[#FF5B00]">
                  <Icon className="h-9 w-9" strokeWidth={1.6} />
                </div>
                <h3 className="mt-4 font-display text-xl font-bold tracking-wide text-[#0B0F19]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">{s.text}</p>
                <div className="mt-4 h-0.5 w-8 bg-[#FF5B00] transition-all duration-500 group-hover:w-16" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
